<div class="row">
    <div class="col-lg-3 col-md-3 col-sm-3 col-12">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Total Leads</span><span class="dash_icon_img"><img
                            src="../../../../assets/images/dashboard_icons/leads.png" /></span></p>
                <h4 class="my-0">*{{totalLeads}}
                    <!-- <span><img src="../../../../assets/images/dashboard_icons/eye.png" /></span> -->
                </h4>
                <!-- <p><a>View Details</a><span class="dash_icon_img"><img src="../../../../assets/images/dashboard_icons/graph.png" /> &nbsp; 16.25%</span></p> -->
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-3 col-12">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Converted Leads</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 success">check_circle</span></span></p>
                <h4 class="my-0">*{{succeedLeads}}
                    <!-- <span><img src="../../../../assets/images/dashboard_icons/eye.png" /></span> -->
                </h4>
                <!-- <p><a>View Details</a><span class="dash_icon_img"><img src="../../../../assets/images/dashboard_icons/graph.png" /> &nbsp; 16.25%</span></p> -->
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-3 col-12">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Pending Leads</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 warning">refresh</span></span></p>
                <h4 class="my-0">*{{pendingLeads}}
                    <!-- <span><img src="../../../../assets/images/dashboard_icons/eye.png" /></span> -->
                </h4>
                <!-- <p><a>View Details</a><span class="dash_icon_img"><img src="../../../../assets/images/dashboard_icons/graph.png" /> &nbsp; 16.25%</span></p> -->
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-3 col-12">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Failed Leads</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 danger">block</span></span></p>
                <h4 class="my-0">*{{failedLeads}}
                    <!-- <span><img src="../../../../assets/images/dashboard_icons/eye.png" /></span> -->
                </h4>
                <!-- <p><a>View Details</a><span class="dash_icon_img"><img src="../../../../assets/images/dashboard_icons/graph.png" /> &nbsp; 16.25%</span></p> -->
            </div>
        </div>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-8 col-12 mt-4">
        <!-- <div class="title_div">
            <h6>Customers <a>View Details</a></h6>
        </div> -->
        <div class="commission_charts-1">
            <div class="row border-bottom my-0 pb-2">
                <div class="col">Customers</div>
                <!-- <div class="col text-end"><a>View Details</a></div> -->
            </div>
            <div class="row">
                <div class="col-12 mh-343">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12" *ngFor="let item of customerLeadsCardList">
                            <div class="customers_div">
                                <ul>
                                    <li><img src="../../../../assets/images/user.png" class="rounded-circle" /> </li>
                                    <li>
                                        <p><b>{{item.Name}}</b><br>{{item.Email}}</p>
                                    </li>
                                    <li>
                                        <p><span>{{item.WhenCreated}}</span></p>
                                    </li>
                                </ul>
                                <div class="customers_block">
                                    <ul>
                                        <li>
                                            <p>Total Policy <br><b>{{item.TotalLeads}}</b></p>
                                        </li>
                                        <li>
                                            <p>Pending Policy <br><b>{{item.PendingLeads}}</b></p>
                                        </li>
                                        <!-- <li><p>Location <br><b>Hyderabad</b></p></li> -->
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4 col-12 mt-1">
        <div class="commission_charts">
            <div class="row border-bottom my-0 pb-2">
                <div class="col-12">Reminders</div>
            </div>
            <div class="row">
                <div class="col-12 mh-343">
                    <div class="row align-items-center border-bottom py-1 my-0 justify-content-between"
                        *ngFor="let item of customerReminderList">
                        <!-- <td style="width: 5%;"><img src="../../../../assets/images/user.png" style="width: 40px;" /> </td>
                <td>{{item.name}} <br><span >Policy expiring in {{item.expiringInDays}} day{{item.expiringInDays > 1 ? 's' : ''}}</span></td>
                <td style="text-align: right;"><a href=""><img src="../../../../assets/images/dashboard_icons/chevron_right.png" /></a> </td> -->
                        <div class="col-10">
                            <p class="mb-0 text-grey2 overflow-hidden text-nowrap font-14" [title]="item.name">
                                {{item.name}}
                            </p>
                            <span class="text-grey3 font-13 d-block"
                                [ngClass]="{'text-danger': item.expiringInDays < 15}">
                                Policy expiring in {{item.expiringInDays}} day{{item.expiringInDays > 1 ? 's' : ''}}
                            </span>
                        </div>
                        <div class="col-auto text-right">
                            <img src="../../../../assets/images/dashboard_icons/chevron_right.png"
                                (click)="getPolicyDetails(item.id, item.expiringInDays)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="overlay" *ngIf="showPolicyDetails">
    <div class="popup2 position-relative col-md-6">
        <div class="modal-header tooltip_ py-1 text-white">
            <h3>Policy Details</h3>
            <button type="button" class="close pull-right svg_white" aria-label="Close" (click)="showPolicyDetails = false">
                <span aria-hidden="true"></span>
            </button>
        </div>
        <div class="modal-body py-2">
            <div class="card-item card row my-0">
                <div class="pt-3 d-block d-sm-block d-md-none row">
                    <div class="col-12">
                        <h3 class="text-main-secondary">Policy Details</h3>
                    </div>
                </div>
                <div class="">
                    <div class="row border-bottom py-0 align-items-center mt-0">
                        <div class="col-2">
                            <img src="../../assets/svgIcon/policyvehicle/{{policyDetails?.policyCategory}}.svg"
                                class="img-fluid h-100 min-width-100">
                        </div>
                        <div class="col-4">
                            <img src="/assets/images/insurance_companies/{{policyDetails?.insuranceCompany}}.png" alt=""
                                class="img-fluid">
                        </div>
                        <div class="col-6 align-self-center">
                            <p class="text-grey2 font-15 mb-0">Plan</p>
                            <p class="mb-0  text-main-secondary">{{policyDetails?.vehicleDetails?.typeOfCover}}</p>
                            <p class="mb-0  text-main-secondary">{{(policyDetails?.policyCategory == 1 ? 'Four Wheeler'
                                : policyDetails?.policyCategory == 2 ? 'Two Wheeler' : policyDetails?.policyCategory ==
                                3 ? 'Comm. Vehicle' : policyDetails?.policyCategory == 4 ? 'Health' :
                                policyDetails?.policyCategory == 5 ? 'Life' : '')+ ' Insurance'}}</p>
                            <p class="mb-0  text-main-secondary fw-bolder">₹ {{policyDetails?.policyValue?.premium > 0 ?
                                policyDetails?.policyValue?.premium : policyDetails?.vehicleDetails?.premium }} (Yearly)
                            </p>
                        </div>
                    </div>
                    <div class="row border-bottom py-1">
                        <div class="col">
                            <p class="text-grey2 font-13 mb-0">Tenure</p>
                            <p class="text-main-secondary font-15 mb-0">{{policyDetails?.policyValue?.policyTerm}} Year
                            </p>
                        </div>
                        <div class="col">
                            <p class="text-grey2 font-13 mb-0">Policy Created Date</p>
                            <p class="text-main-secondary font-15-12 mb-0">{{policyDetails?.createdAt |
                                date:'dd-MMM-yyyy'}}</p>
                        </div>
                        <div class="col">
                            <p class="text-grey2 font-13 mb-0">Policy Start Date</p>
                            <p class="text-main-secondary font-15 mb-0">{{policyDetails?.policyValue?.startDate |
                                date:'dd-MMM-yyyy'}}</p>
                        </div>
                        <div class="col">
                            <p class="text-grey2 font-13 mb-0">Policy End Date</p>
                            <p class="text-main-secondary font-15 mb-0">{{policyDetails?.policyValue?.endDate |
                                date:'dd-MMM-yyyy'}}</p>
                        </div>
                    </div>
                    <div class="row border-bottom py-1">
                        <div class="col">
                            <p class="text-grey2 font-13 mb-0">Status</p>
                            <p class="text-main-secondary font-15 mb-0">{{ policyDetails?.quoteId }}</p>
                        </div>
                        <div class="col">
                            <p class="text-grey2 font-13 mb-0 d-flex align-items-center">Policy Number <span
                                    class="d-none material-symbols-outlined mx-1 icon font-18 cursor-pointer"
                                    (click)="DownloadPolicy()" title="Download Policy"> download </span></p>
                            <p class="text-main-secondary font-15 mb-0">{{policyDetails?.policyValue?.policyNumber |
                                uppercase}}</p>
                        </div>
                    </div>
                    <div class="row border-bottom py-1">
                        <div class="col-md-6">
                            <p class="text-grey2 font-13 mb-0">Proposer</p>
                            <p class="text-main-secondary font-15 mb-0">{{policyDetails?.proposerDetails?.firstName}}
                                {{policyDetails?.proposerDetails?.lastName}}</p>
                        </div>
                        <div class="col-md-6">
                            <p class="text-grey2 font-14 mb-0 d-flex align-items-center"><span _ngcontent-udg-c121=""
                                    class="material-symbols-outlined font-15"> call </span> :
                                {{policyDetails?.proposerDetails?.phoneNumber}}</p>
                            <p class="text-grey2 font-14 mb-0 d-flex align-items-center"><span _ngcontent-udg-c121=""
                                    class="material-symbols-outlined font-16"> mail </span> :
                                {{policyDetails?.proposerDetails?.email}}</p>
                        </div>
                    </div>
                    <div class="row  border-bottom py-1"
                        *ngIf="policyDetails?.policyCategory == 1 || policyDetails?.policyCategory == 2 || policyDetails?.policyCategory == 3">
                        <div class="col">
                            <!-- <p class="text-grey2 mb-1 font-13">{{(policyDetails?.policyCategory == 1 ? 'Four Wheeler' : policyDetails?.policyCategory == 2 ? 'Two Wheeler' : policyDetails?.policyCategory == 3 ? 'Commercial' : '')+ ' Vehicle Number'}}</p> -->
                            <p class="text-grey2 font-13 mb-0">Registration Number</p>
                            <p class="text-main-secondary font-15 mb-0">
                                {{policyDetails?.vehicleDetails?.registrationNumber}}</p>
                        </div>
                        <div class="col">
                            <p class="text-grey2 font-13 mb-0">Manufacture/Model</p>
                            <p class="text-main-secondary font-15 mb-0">{{policyDetails?.vehicleDetails?.make}},
                                {{policyDetails?.vehicleDetails?.model}}</p>
                        </div>
                    </div>
                    <div class="row py-1"
                        *ngIf="policyDetails?.policyCategory == 1 || policyDetails?.policyCategory == 2 || policyDetails?.policyCategory == 3">
                        <div class="col text-center">
                            <app-custom-button text="Download Policy" [width]="'max-content'" className=""
                                [height]="'34px'" leadingIconName="" (onClick)="DownloadPolicy()"></app-custom-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>